interface DataTableSkeletonProps {
  columns: number;
  rows?: number;
  showFilters?: boolean;
  showPagination?: boolean;
}

export default function DataTableSkeleton({
  columns,
  rows = 8,
  showFilters = true,
  showPagination = true
}: DataTableSkeletonProps) {
  return (
    <div className="datatable-skeleton">
      {showFilters && (
        <div className="d-flex justify-content-between mb-5">
          <div className="skeleton skeleton-input w-250px"></div>
          <div className="d-flex gap-2">
            <div className="skeleton skeleton-button w-120px"></div>
            <div className="skeleton skeleton-button w-120px"></div>
          </div>
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-row-bordered">
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i}>
                  <div className="skeleton skeleton-text w-75"></div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: rows }).map((_, r) => (
              <tr key={r}>
                {Array.from({ length: columns }).map((_, c) => (
                  <td key={c}>
                    <div className="skeleton skeleton-text"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showPagination && (
        <div className="d-flex justify-content-between mt-4">
          <div className="skeleton skeleton-text w-150px"></div>
          <div className="d-flex gap-2">
            <div className="skeleton skeleton-circle"></div>
            <div className="skeleton skeleton-circle"></div>
            <div className="skeleton skeleton-circle"></div>
          </div>
        </div>
      )}
    </div>
  );
}
